module.exports = __webpack_public_path__ + "img/TrendBioScience.bde51a68.png";